import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UILink from 'UIComponents/link/UILink';
import { ReviewMetadataColumn, StyledMetadataValue } from 'automation-ui-canvas/containers/review/StyledMetadataDetails';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import AssetActions from 'campaigns-lib/data/AssetActions';
import { AssetTypes } from 'campaigns-lib/constants/AssetTypes';
import { getWorkflowId } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import { getCrmSearchCampaign } from 'campaigns-lib/data/CampaignDao';
import { useEffect, useState } from 'react';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CampaignMetadata = ({
  flow,
  handleOpenPanelWithRedirect
}) => {
  const [campaigns, setCampaigns] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const workflowId = getWorkflowId(flow);
  useEffect(() => {
    AssetActions[AssetTypes.WORKFLOW].fetch(workflowId).then(associatedCampaigns => {
      setIsLoading(true);
      return getCrmSearchCampaign(associatedCampaigns).then(response => {
        setCampaigns(response.results);
      });
    }).catch(err => {
      console.warn(err);
    }).finally(() => {
      setIsLoading(false);
    });
  }, [workflowId]);
  return /*#__PURE__*/_jsxs(ReviewMetadataColumn, {
    children: [/*#__PURE__*/_jsx(UIFormLabel, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformReview.v2.detailsStep.campaign"
      })
    }), isLoading ? /*#__PURE__*/_jsx(SkeletonText, {}) : campaigns && campaigns.length ? campaigns === null || campaigns === void 0 ? void 0 : campaigns.map(campaign => /*#__PURE__*/_jsx(StyledMetadataValue, {
      children: /*#__PURE__*/_jsx(UITruncateString, {
        maxWidth: 150,
        children: campaign.display_name
      })
    }, campaign.guid)) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "platformReview.v2.detailsStep.none"
    }), /*#__PURE__*/_jsx(UILink, {
      onClick: () => {
        handleOpenPanelWithRedirect('campaign');
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformReview.v2.detailsStep.editCampaign"
      })
    })]
  });
};
export default CampaignMetadata;